import { render } from "./transparansi_anggaran.vue?vue&type=template&id=bd7598b6&scoped=true"
import script from "./transparansi_anggaran.vue?vue&type=script&lang=js"
export * from "./transparansi_anggaran.vue?vue&type=script&lang=js"

import "./transparansi_anggaran.vue?vue&type=style&index=0&id=bd7598b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd7598b6"]])

export default __exports__